if (typeof window !== 'undefined') {
  window.process = window.process || {}
  window.process.env = window.process.env || {}
  window.process.env.BROWSER = true
  window.process.env.BUILD_ENV = 'production'
}
